module.exports = __webpack_public_path__ + "img/heat.8bb6a57c.png";